export default "__VITE_ASSET__BiY_k6I8__"